import { render, staticRenderFns } from "./TenantEditCatalog.vue?vue&type=template&id=1b68e3b8&scoped=true&"
import script from "./TenantEditCatalog.vue?vue&type=script&lang=js&"
export * from "./TenantEditCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b68e3b8",
  null
  
)

export default component.exports